import React from 'react';
import { CaseStudiesSection } from './components/CaseStudiesSection';
import { CookieScriptLoader } from './components/CookieScriptLoader';
import { FAQSection } from './components/FAQSection';
import { FeaturesSection } from './components/FeaturesSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { GoogleTagLoader } from './components/GoogleTagLoader';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { Metadata } from './components/Metadata';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { ResultsSection } from './components/ResultsSection';
import { TeamSection } from './components/TeamSection';
export function App() {
  return <div className="min-h-screen w-full bg-white font-sans text-gray-900" data-id="element-0" data-mp="28skzynbjv4a8">
      <CookieScriptLoader data-id="element-1" data-mp="23ujlygszdv5m" />
      <GoogleTagLoader data-id="element-2" data-mp="23t8fuac2cbbc" />
      <Metadata data-id="element-3" data-mp="3ik7gwiph6frp" />
      <Header data-id="element-4" data-mp="3ikh5q2ysagvt" />
      <main data-id="element-5" data-mp="3iiwfuqnezm4a">
        <HeroSection data-id="element-6" data-mp="3ijfx0558q6h9" />
        <ProblemSection data-id="element-7" data-mp="3ihv0i9zd8dgr" />
        <FeaturesSection data-id="element-8" data-mp="3mlavl1vse5rc" />
        <ResultsSection data-id="element-9" data-mp="3mkhlps1j704z" />
        <CaseStudiesSection data-id="element-10" data-mp="3mjztd6hzp62c" />
        <TeamSection data-id="element-11" data-mp="3mj6lg27aoaim" />
        <PricingSection data-id="element-12" data-mp="3rbra6pbcfxfa" />
        <FAQSection data-id="element-13" data-mp="3rdatypw7kqlt" />
        <FinalCTASection data-id="element-14" data-mp="3rd1all5o5hp3" />
      </main>
      <Footer data-id="element-15" data-mp="5otf64sd496" />
    </div>;
}